import { atom } from 'jotai';
import { DeviceOptions } from './device_option';
const DEFAULT_DEVICE = DeviceOptions.iphonese;
export const selectedDeviceAtom = atom(DEFAULT_DEVICE);
export const deviceIsLandscapeAtom = atom(false);
export const deviceZoomLevelAtom = atom(1);
selectedDeviceAtom.debugLabel = 'selectedDeviceAtom';
deviceIsLandscapeAtom.debugLabel = 'deviceIsLandscapeAtom';
deviceZoomLevelAtom.debugLabel = 'deviceZoomLevelAtom';
